<div [ngxSummernote]="summernoteConfig" [ngModel]="htmlText" (ngModelChange)="cambia($event)"></div>
